
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getDt from '../../utils';
import { showLoader } from '../redux/ctrl/ctrlActions';
import { updTagAct } from '../redux/project/projActions';
//import Select from 'react-select';
import './pkgSel.scss';


function GetPkgs(getPkgs, id) {
  //    let getPkgs = useSelector(state=>state.project.packages);
  let fPkgs = getPkgs.filter(o => o.package_id != id);
  return fPkgs;
}

/*const MultiTagComboStyle = {
  control: (base, state) => ({
    ...base,
    background: "#fff",
    // match with the menu
    borderRadius: 0,
    // Overwrittes the different states of border
    borderColor: state.isFocused ? "#80bdff": "#ced4da",
    // Removes weird border around container
    boxShadow: null,
    '&:hover': {
      borderColor: '#c6c6c6;'
    },
    height: '25px',
    'min-height': '25px',
     width: '150px',
  }),
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: 0,
    // beautify the word cut by adding a dash see https://caniuse.com/#search=hyphens for the compatibility
    hyphens: "auto",
    // kill the gap
    marginTop: 0,
    textAlign: "left",
    // prevent menu to scroll y
    wordWrap: "break-word",
  }),
  menuList: base => ({
    ...base,
    // kill the white space on first and last option
    padding: 0
 
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 12px',
    paddingBottom: '6px'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: '4px', 
    color: "hsl(0,0%,60%)"
  }),
  indicatorsContainer: (styles) => ({
     ...styles,
  }),
  indicatorSeparator: (styles) => ({
     ...styles,
     display: 'none'
  }),
  clearIndicator: (styles) => ({
      ...styles,
      marginBottom: 0,
      marginTop: '-2px'
  }),
  singleValue : (style) => ({
     ...style,
     paddingBottom: '0.2pc'
  }),
  multiValue: (styles) => ({
    ...styles,
    marginBottom:'8px'
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    padding: '2px'
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    paddingLeft: '2px',
    paddingRight: '2px'
  }),
  menuPortal: (base) => ({ 
    ...base, 
    zIndex: 9999 
  })
};
 
*/
function PkgSelRenderer(props) {
  let getPkgs = useSelector(state => state.project.packages);
  let getPkgs1 = useSelector(state => state.project.get);
  const prof = useSelector(state => state.profile)
  const [pkg, setPkg] = useState();
  const pkgs = GetPkgs(getPkgs, props.data.package_id);
  const dispatch = useDispatch();

  function getVal(obj, id) {
    let dval = obj.find((o) => o.package_id == id)?.package_name
    return dval
  }

  const onPkgChange = (event, props) => {
    const pl = props.data;
    pl[props.column.colDef.field] = event.target.value.trim();
    pl['package_id'] = event.target.options[event.target.selectedIndex].getAttribute('package_id');
    pl['last_updatedby'] = prof.email;
    pl['last_updatedate'] = getDt(new Date())
    pl['creation_date'] = getDt(new Date())
    pl['selected'] = 'Y';
    dispatch(showLoader(true))
    dispatch(updTagAct(pl))
    dispatch(showLoader(false))
  }
  return (
    <div>
      <select value={pkg} onChange={(event) => onPkgChange(event, props)} className="dd" disabled={true}>
        <option package_id={props.data.package_id} key={props.data.package_id} >{getVal(getPkgs, props.data.package_id)} </option>
        {pkgs.map(o => <option package_id={o.package_id} key={o.package_id} value={o.package_name}> {o.package_name}</option>)}
      </select>
      {/*<Select styles={MultiTagComboStyle} menuPortalTarget={document.body} 
                  name="exist_pkgs"  options={eprojs.getPkgs} placeholder='Package...'
    />*/ }
    </div>
  )
}

export default PkgSelRenderer;